<template>
  <div class="modal fade" id="addUser" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
     <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add User</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label pt-2">Users</label>
              <v-select multiple v-model="selectedUsers" :options="userList" label="fullName" :reduce="userList => userList.id"
                        placeholder="Please Select a Users"/>
            </div>
            <div class="modal-footer">
              <button class="btn" @click="TryAddUserProject()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
                <font-awesome-icon icon="save"/>
                <span class="mx-1">Save</span>
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"
    import vSelect from "vue-select";
    export default {
        name: "AddUser",
        props: ['isActiveUserModal', 'projectId','userId'],
        components:{
          vSelect
        },
        data() {
            return {
              selectedUsers: [],
              userForm: {
                userId: [],
                projectId: 0,
              },
            }
        },
        computed: {
          ...mapState('projects', ['userProject']),
          ...mapState('users' , ['userList']),
        },
        methods: {
           ...mapActions('users', ["getUsers"]),
           ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),

            openCloseUserModal() {
                this.selectedUsers = [];
                this.$emit('openCloseUserModal');
            },
            async TryAddUserProject() {
                try {
                  this.userForm.projectId = parseInt(this.projectId);
                  this.userForm.userId = this.selectedUsers;
                  await this.addUserProject(this.userForm);
                  await this.getUserProject(this.projectId);
                  this.selectedUsers = [];
                  this.openCloseUserModal();
                  this.$notify({title: "Success", type: "success", text: "Successfully added users."})

                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                }
            },
        },
        mounted() {
          document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveUserModal = false;
                }
            })
        },
      created() {
          this.getUsers();
      }
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
